<script setup lang="ts">
import { computed } from 'vue'
// types
import type { StrapiFooter, StrapiFooterLinkColumn } from '@ts-strapi/interfaces'
// components
import FooterColumn from '@Widgets/Footers/FooterColumn.vue'
import FooterSocials from '@Widgets/Footers/FooterSocials.vue'
import FooterBadgeGrid from '@Widgets/Footers/FooterBadgeGrid.vue'
import FooterBottomRow from '@Widgets/Footers/FooterBottomRow.vue'

const ASIDE_COLUMN_COUNT = 2

defineOptions({
  name: 'FooterDesktop',
})

const props = defineProps<{
  data: StrapiFooter
}>()

const refMainColumns = computed<StrapiFooterLinkColumn[]>(
  () => props.data.columns.slice(0, Math.max(0, props.data.columns.length - ASIDE_COLUMN_COUNT)),
)

const refAsideColumns = computed<StrapiFooterLinkColumn[]>(
  () => props.data.columns.slice(-ASIDE_COLUMN_COUNT),
)
</script>

<template>
  <footer class="footer-desktop">
    <div class="footer-desktop__inner">
      <section class="footer-desktop__columns">
        <FooterColumn
          v-for="col in refMainColumns"
          :key="col.title"
          :column="col"
        />
      </section>

      <aside class="footer-desktop__aside">
        <FooterBadgeGrid
          v-if="data.paymentBadges.length"
          :items="data.paymentBadges"
          variant="payment"
        />
        <FooterBadgeGrid
          v-if="data.trustBadges.length"
          :items="data.trustBadges"
          variant="trust"
        />
        <FooterSocials
          v-if="data.socials.length"
          :label="data.followUsLabel"
          :items="data.socials"
        />
        <FooterColumn
          v-for="col in refAsideColumns"
          :key="col.title"
          :column="col"
        />
      </aside>
    </div>

    <div class="footer-desktop__bottom-tablet">
      <FooterBottomRow
        :items="data.bottomItems"
        variant="mobile"
      />
    </div>
    <div class="footer-desktop__bottom-desktop">
      <FooterBottomRow
        :items="data.bottomItems"
        variant="desktop"
      />
    </div>
  </footer>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Footers/FooterDesktop.scss" />